import { BatchDeleteRequest, TagInputModel, TagModel, TagsListPaginated } from 'types/TagTypes';
import useHttp from '../helpers/HttpMethods';

class TagsService {
  /**
   * Lista todas as tags paginadas.
   * @param {string} filters - filtros para a consulta.
   * @returns {Promise<TagsListPaginated>}
   */
  static async list(filters?: string): Promise<TagsListPaginated> {
    return await useHttp().get(`/tags?${filters}`);
  }

  /**
   * Busca uma tag pelo ID.
   * @param {number} id - id da tag.
   * @returns {Promise<Response | TagModel>}
   */
  static async findById(id: number): Promise<Response | TagInputModel> {
    return await useHttp().get(`/tags/${id}`);
  }

  /**
   * Cria uma nova tag.
   * @param {TagInputModel} body - dados da tag a ser criada.
   * @returns {Promise<TagModel>}
   */
  static async create(body: TagInputModel): Promise<TagModel> {
    return await useHttp().post(body, `/tags`);
  }

  /**
   * Edita uma tag existente.
   * @param {TagInputModel} body - dados atualizados da tag.
   * @param {number} id - id da tag a ser editada.
   * @returns {Promise<Response | TagModel>}
   */
  static async edit(body: TagInputModel, id: number): Promise<Response | TagModel> {
    return await useHttp().put(body, `/tags/${id}`);
  }

  /**
   * Exclui uma tag pelo ID.
   * @param {number} id - id da tag a ser excluída.
   * @returns {Promise<Response>}
   */
  static async delete(id: number): Promise<Response> {
    return await useHttp().del(`/tags/${id}`);
  }

  /**
   * Exclui múltiplas tags em lote.
   * @param {BatchDeleteRequest} body - objeto contendo array de IDs das tags a serem excluídas.
   * @returns {Promise<Response>}
   */
  static async batchDelete(body: BatchDeleteRequest): Promise<Response> {
    return await useHttp().delWithBody(body, `/tags/batch-delete`);
  }
}

export default TagsService;